import { styled, Typography } from '@mui/material'

export const FeedbackContent = styled(Typography)(({ theme }) => ({
  '& *': {
    color: 'inherit',
  },
  '& p, & p.MuiTypography-root, & strong': {
    marginTop: 0,
    marginBottom: 0,
    wordWrap: 'normal !important',
    fontSize: theme.typography.body2.fontSize,
    lineHeight: theme.typography.body2.lineHeight,
  },
  // Remove margin when paragraph only contains a <br> tag
  '& p:has(> br:only-child)': {
    marginBottom: 0,
  },
  '& .ql-editor': {
    whiteSpace: 'normal !important',
    padding: 0,
  },
  '& .katex': {
    whiteSpace: 'nowrap',
    lineHeight: '1.125rem',
    fontSize: 'inherit',
  },
  '& .katex *': {
    lineHeight: 'inherit',
  },
})) as typeof Typography
